import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from "../../Context/UserContext";
import WelcomePageBanner from "../../assets/images/WelcomePageBanner.png";
import { CgProfile } from "react-icons/cg";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosClient from '../../axios-client';
import CountDown from './Countdown';
import { Link, useNavigate } from 'react-router-dom';
import { TbArrowBackUp } from 'react-icons/tb';
function MySubscription() {
    const { user } = useContext(AuthContext);
    const [subscription, setSubscription] = useState();
    const navigate = useNavigate()
    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                const response = await axiosClient.get(`subscriptions/${user.last_active_payment.subscription}/`); // Replace with your actual API endpoint
                setSubscription(response.data);
            } catch (error) {
                // console.error("Error fetching subscriptions:", error);
            }
        };

        fetchSubscriptions();
    }, [user]);
    return (
        <section
            className="relative py-10 px-3  min-h-[100vh] flex-col flex items-center justify-center"  // Ensures the section takes the full height and centers content
            style={{
                background: `url(${WelcomePageBanner})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundAttachment: "fixed",
            }}
        >
            <ToastContainer />
            <Link
                to={"/profile"}
                className="absolute top-2 right-2 flex items-center justify-center bg-black/20 rounded-full p-2.5 cursor-pointer"
                title="Profil"
            >
                <CgProfile size={"26px"} className="text-orange-500" />
            </Link>
            <Link
                          onClick={()=>navigate(-1)}
                          className="absolute top-2 left-2 flex items-center justify-center bg-black/20 rounded-full p-2.5 cursor-pointer"
                          title="Se déconnecter"
                        >
                          <TbArrowBackUp size={"26px"} className="text-orange-500" />
                        </Link>
            <div key={subscription?.id} className="w-80 p-5 bg-white text-center rounded-2xl shadow-xl flex flex-col justify-between">
                <div>
                    <div className="h-[130px]">
                        <h1 className="text-black mb-2 font-semibold text-2xl">
                            {subscription?.name}
                        </h1>
                        <h5>{subscription?.description}</h5>
                        <p className="pt-2 tracking-wide">
                            <span className="text-orange-400 align-top">€ </span>
                            <span className="text-3xl text-orange-400 font-semibold">{subscription?.price}</span>
                            <span className="text-orange-400 font-medium"> / {subscription?.type === "ANNUEL" ? "Année" : "Mois"}</span>
                        </p>
                    </div>

                    <hr className="mt-4 border-1" />
                    <div className="pt-5 flex flex-col justify-center items-center">
                        {subscription?.features.map((feature, index) => (
                            <p key={index} className="text-sm font-semibold text-black text-left pt-3">
                                <span>{feature}</span>
                            </p>
                        ))}
                    </div>
                </div>
                <hr className="mt-4 border-1" />
                <div className="gap-3 flex flex-col mt-4">
                    {/* Countdown Component */}
                    {user.last_active_payment?.start_date && (
                        <p className="text-orange-500 text-sm font-semibold">
                            Commencé le: {new Date(user.last_active_payment.start_date).toLocaleString("fr-FR", {
                                month: "short",
                                day: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: false, // 24-hour format
                            })}
                        </p>
                    )}
                    
                    {user.last_active_payment?.end_date && (
                        <CountDown endDate={user.last_active_payment?.end_date} />

                    )}
                </div>
            </div>
        </section>
    )
}

export default MySubscription